import React, {useState} from "react"
import Modal from "../../components/My/Modal";
import {Form} from "react-final-form";
import SubjectField from "../../FinalForm/api/SubjectField";
import {Button} from "../../components/My/Button";
import InputField from "../../FinalForm/InputField";
import CheckboxField from "../../FinalForm/CheckboxField";
import {apiCreateUser, apiUpdateUser} from "./Actions";

const UserFormModal = ({visible, data, close}) => {

    let [loading, setLoading] = useState(false)

    let submit
    const save = (values) => {
        setLoading(true)
        if(!data) {
            apiCreateUser((values), (data) => {
                setLoading(false)
                close(true)
            }, error => {
                //USER_EXIST
                setLoading(false)
            })
        }else{
            apiUpdateUser((values), (data) => {
                setLoading(false)
                close(true)
            }, error => {
                //USER_EXIST
                setLoading(false)
            })
        }
    }

    const init = () => {
        if (!data) return {}
        return data
    }

    const getBody = () => {
        return (
            <Form onSubmit={save} initialValues={init()} render={({handleSubmit, values}) => {
                submit = handleSubmit
                return (
                    <div>
                        <SubjectField name={"subjects"} label={"Vyberte subjekt"} validate={value => !value}
                                      isMulti={true} filters={{systemSubject:true}}
                                      onEnter={() => handleSubmit()}/>
                        <div className={"flex flex-wrap w-full"}>
                            <div className={"w-1/2"}>
                                <InputField label={"Login"} name={"login"} isMandatory={true}/>
                            </div>
                            <div className={"w-1/2"}>
                                <InputField label={"Jméno uživatele"} name={"name"} isMandatory={true}/>
                            </div>
                            {data &&
                                <div className={"w-1/2"}>
                                    <CheckboxField label={"Chci zadat nové heslo"} name={"isNewPassword"}/>
                                </div>
                            }
                            <div className={"w-full"}>
                                {(values.isNewPassword || !data) &&
                                    <InputField label={!data ? "Heslo" : "Nové heslo"} name={"password"}
                                                isMandatory={values.isNewPassword || !data}
                                                disabled={!values.isNewPassword && data}/>
                                }
                            </div>
                            <div className={"w-1/3"}>
                                <CheckboxField label={"Aktivní"} name={"active"}/>
                            </div>
                            <div className={"w-1/3"}>
                                <CheckboxField label={"Super Admin"} name={"rights.superAdmin"}/>
                            </div>
                            <h4 className={"w-full"}>Práva</h4>
                            <div className={"w-1/3"}>
                                <CheckboxField label={"Dashboard"} name={"rights.dashboard"}/>
                            </div>
                            <div className={"w-1/3"}>
                                <CheckboxField label={"Nahrávání událostí"} name={"rights.events"}/>
                            </div>
                            <div className={"w-1/3"}>
                                <CheckboxField label={"Validace vstupenky"} name={"rights.validation"}/>
                            </div>
                            <div className={"w-1/3"}>
                                <CheckboxField label={"Uživatelé"} name={"rights.users"}/>
                            </div>
                            <div className={"w-1/3"}>
                                <CheckboxField label={"Subjekty"} name={"rights.subjects"}/>
                            </div>
                            <div className={"w-1/3"}>
                                <CheckboxField label={"Události aréna"} name={"rights.arenaEvents"}/>
                            </div>
                            <div className={"w-1/3"}>
                                <CheckboxField label={"Čtečky"} name={"rights.readers"}/>
                            </div>
                            <div className={"w-1/3"}>
                                <CheckboxField label={"Připojení"} name={"rights.connections"}/>
                            </div>
                            <div className={"w-1/3"}>
                                <CheckboxField label={"Pravidla turniketů"} name={"rights.turniketRule"}/>
                            </div>
                            <div className={"w-1/3"}>
                                <CheckboxField label={"ENIGOO TURNIKETY"} name={"rights.enigooTurnikets"}/>
                            </div>
                            <div className={"w-1/3"}>
                                <CheckboxField label={"ENIGOO TURNIKETY editace"} name={"rights.enigooTurniketsEdit"}/>
                            </div>
                            <div className={"w-1/3"}>
                                <CheckboxField label={"Výstaviště ČB"} name={"rights.vcb"}/>
                            </div>
                            <div className={"w-1/3"}>
                                <CheckboxField label={"Výstaviště ČB nastavení"} name={"rights.vcbSettings"}/>
                            </div>
                            <div className={"w-1/3"}>
                                <CheckboxField label={"Logy kiosky"} name={"rights.kioskLog"}/>
                            </div>
                            <div className={"w-1/3"}>
                                <CheckboxField label={"Cron"} name={"rights.cron"}/>
                            </div>
                            <div className={"w-1/3"}>
                                <CheckboxField label={"Parkování ENIGOO"} name={"rights.parking"}/>
                            </div>
                        </div>
                    </div>
                )
            }}/>)

    }

    if (!visible) return null
    return (
        <>
            <Modal body={getBody()} title={!data ? "Vytvořit uživatele" : "Upravit uživatele"} visible={visible}
                   close={() => close(null)}
                   footer={<>
                       <Button outline={true} text={"Zavřít"} onClick={() => close()}/>
                       <Button text={"Potvrdit"} onClick={() => submit()} loading={loading}/>
                   </>
                   }
            />
        </>
    )

}

export default UserFormModal
